import { render, staticRenderFns } from "./refer-coupon-select-dialog.vue?vue&type=template&id=5c3a942f&scoped=true&"
import script from "./refer-coupon-select-dialog.vue?vue&type=script&lang=js&"
export * from "./refer-coupon-select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./refer-coupon-select-dialog.vue?vue&type=style&index=0&id=5c3a942f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3a942f",
  null
  
)

export default component.exports